import { configureStore, } from "@reduxjs/toolkit";

import rootReducer from "./reducers/rootReducer";


const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
});

export type RootState = ReturnType<typeof store.getState>
export type DispatchType = typeof store.dispatch;


export const state = store.getState();


export default store;